import { classNames } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import './QuoteBanner.scss';
/**
 * @component QuoteBanner
 * @since 1.0.0
 */
export function QuoteBanner(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { data, configurationFields } = props;
    if (data == null) {
        return null;
    }
    const className = classNames('quote-view-banner', props.className);
    const defaultHeaderVideo = configurationFields
        ? getConfigurationFieldValue(configurationFields, 'DEFAULT_HEADER_VIDEO')
        : null;
    const hasHeaderVideo = ((_a = data === null || data === void 0 ? void 0 : data.medias) === null || _a === void 0 ? void 0 : _a.find((media) => media.type === 'HEADER_VIDEO'))
        ? (_c = (_b = data === null || data === void 0 ? void 0 : data.medias) === null || _b === void 0 ? void 0 : _b.find((media) => media.type === 'HEADER_VIDEO')) === null || _c === void 0 ? void 0 : _c.url
        : null;
    const defaultHeaderImage = getConfigurationFieldValue(configurationFields, (data === null || data === void 0 ? void 0 : data.directSale)
        ? 'DIRECT_SALES_FORM_HEADER_IMAGE'
        : 'DEFAULT_HEADER_IMAGE', true);
    const hasHeaderImage = ((_d = data === null || data === void 0 ? void 0 : data.medias) === null || _d === void 0 ? void 0 : _d.find((media) => media.type === 'HEADER_IMAGE'))
        ? (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.medias) === null || _e === void 0 ? void 0 : _e.find((media) => media.type === 'HEADER_IMAGE')) === null || _f === void 0 ? void 0 : _f.media) === null || _g === void 0 ? void 0 : _g.url
        : null;
    const mediaType = hasHeaderVideo
        ? 'HEADER_VIDEO'
        : hasHeaderImage
            ? 'HEADER_IMAGE'
            : defaultHeaderVideo
                ? 'HEADER_VIDEO'
                : 'HEADER_IMAGE';
    const headerImage = hasHeaderImage || defaultHeaderImage;
    let headerVideo = hasHeaderVideo || defaultHeaderVideo;
    // if headerVideo is a youtube video, we need to add the playlist parameter
    if (headerVideo && headerVideo.includes('youtube.com')) {
        // get video id from url embed (https://www.youtube.com/embed/2JOwdxvRJaw?si=p-Um4tNfEjwZ3j0-)
        const videoId = headerVideo.split('embed/')[1].split('?')[0];
        headerVideo = headerVideo + '&playlist=' + videoId;
    }
    return (React.createElement("div", { id: "quote-view-banner", className: className },
        React.createElement("div", { className: "quote-view-banner-background", style: { backgroundImage: 'url(' + encodeURI(headerImage) + ')' } },
            mediaType === 'HEADER_VIDEO' && headerVideo.includes('mp4') && (React.createElement("video", { autoPlay: true, loop: true, muted: true, playsInline: true },
                React.createElement("source", { src: headerVideo, type: "video/mp4" }),
                "Your browser does not support the video tag")),
            mediaType === 'HEADER_VIDEO' && !headerVideo.includes('mp4') && (React.createElement("iframe", { src: headerVideo + '&autoplay=1&mute=1&loop=1&showinfo=0', frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", allowFullScreen: true }))),
        React.createElement("div", { className: "quote-view-banner-foreground" },
            React.createElement(Text, { className: "quote-view-banner-title", value: (_h = data === null || data === void 0 ? void 0 : data.translations.find((translation) => translation.language.code === data.language)) === null || _h === void 0 ? void 0 : _h.headline, html: true }),
            React.createElement("div", { className: "quote-view-banner-arrow" },
                React.createElement(Icon, { value: "arrow-down" })))));
}
